'use client';

import { CatInlineNotification } from '@blocks-react/components/InlineNotification';
import { CatIconSuccess } from '@blocks-react/components/Icons/Success';
import { CatIconWarningTriangle } from '@blocks-react/components/Icons/WarningTriangle';
import { CatIconWarningCircle } from '@blocks-react/components/Icons/WarningCircle';
import React, { useEffect, useRef } from 'react';
import { BlocksInlineNotification } from '@blocks-web-components/components/inline-notification/inline-notification';

export const CAT_BANNER_ICON_TYPES = {
  ERROR: 'error',
  SUCCESS: 'success',
  WARNING: 'warning'
};

type Props = {
  heading?: string;
  variant: 'error' | 'warning' | 'success';
  ignoreScroll?: boolean;
  children?: React.JSX.Element | React.JSX.Element[];
};

export const AssociatedDealerBanner = ({
  heading,
  variant,
  ignoreScroll = false,
  children
}: Props) => {
  const { SUCCESS, WARNING, ERROR } = CAT_BANNER_ICON_TYPES;
  const ref = useRef<BlocksInlineNotification>(null);

  useEffect(() => {
    if (ref.current && variant === ERROR && !ignoreScroll) {
      ref.current.scrollIntoView({
        behavior: 'smooth'
      });
    }
  }, [ref, variant, ignoreScroll, ERROR]);

  return (
    <CatInlineNotification
      heading={heading}
      variant={variant}
      data-testid="cat-banner"
      ref={ref}
    >
      {variant === ERROR ? (
        <CatIconWarningCircle
          slot="before"
          data-testid="error-icon"
          className="mt-1"
        />
      ) : null}
      {variant === SUCCESS ? (
        <CatIconSuccess
          slot="before"
          data-testid="success-icon"
          className="mt-1"
        />
      ) : null}
      {variant === WARNING ? (
        <CatIconWarningTriangle
          slot="before"
          data-testid="warning-icon"
          className="mt-1"
        />
      ) : null}
      <span className="align-middle cat-u-theme-typography-body-sm u-color--ExtraDarkGray">
        {children}
      </span>
    </CatInlineNotification>
  );
};
